import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { IconComponent } from '@app/shared/components/icon/icon.component';

@Component({
  selector: 'c-brand-moment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  templateUrl: './brand-moment.component.html',
  styleUrl: './brand-moment.component.scss',
  host: { '[class]': "size()" },
})
export class BrandMomentComponent {
  readonly image = input<string>();
  readonly size = input<'lg' | 'xl'>('lg');
  readonly icon = input<IconProp>();
  readonly title = input<string>();
  readonly description = input<string>();
}
